module.exports = __webpack_public_path__ + "static/react-breadcrumbs-demo-e3d7f9ddfed4d5c8e023e52286182973.jpg";